const Feedback = (client) => ({
  submit(attributes) {
    return client.post('/api/v3/open/feedback', attributes);
  },
});

export default Feedback;
